module.exports = __webpack_public_path__ + "smile_black.2e86bc22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/black/smile_black.png
// module id = 492
// module chunks = 0